import * as MessageActions from 'actions/Messages';

export default function messagesReducer(messages, action) {
    switch (action.type) {
        case MessageActions.SUCCESS_GET_NEW_MESSAGES_COUNT:
            messages = messages.set('newMessagesCount', action.data.Result);
    }

    return messages;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/messagesReducer.js